import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Blog } from '../../models/blog/blog-model';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ProfileService } from '../../services/profile/profile.service';
import { CategoryService } from '../../services/category/category.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
    selector: 'app-create-blog',
    templateUrl: './create-blog.component.html',
    styleUrls: ['./create-blog.component.css']
})
/** create-blog component*/
export class CreateBlogComponent {
  /** create-blog ctor */
  public blog = new Blog();
  public mediaList: MediaLibrary[];
  fileToUpload: File;
  fd = new FormData();
  userId: number;
  mediaImageShow: boolean;
  blogCategoryId: number = 0;
  selectedBlogLogo: string;
  public longDetail: any;
  public websiteName: string;
  public blogCategoryList: BlogCategory[];
  //public blogStatus: string[];
  public blogStatus: any[] = [];
  isUnique = true;
  validate: boolean;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  constructor(private readonly blogService: BlogCategoryService, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly categoryService: CategoryService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService, private readonly router: Router, private readonly rolePermissionService: RolePermissionService){
    this.checkPermission();
    this.toastr.setRootViewContainerRef(vcr);
    this.blog.metaDescription = "";
    this.blog.metaKeyword = "";
    this.blog.metaTitle = "";
    this.blog.sortOrder = 0;
    this.blog.isActive = true;
    this.GetBlogCategoryList();
    // this.GetBlogStatus();
    this.blog.blogStatus = "";
    this.blog.blogCategoryId = null;
    this.validate = true;
    this.mediaImageShow = true;
    this.blog.blogId = 0;
    this.profileService.getProfile().subscribe(
      data => {
        if (data) {
          this.blog.userId = data.userID;
          this.userId = data.userID;
        }
        else {
          this.blog.userId = 0;
        }
      });
    this.GetSystemSettingFirstOrDefault();

  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("blog").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            
          }
          else {
            this.router.navigate(["/blog-list"]);
          }
        }
        else {
          this.router.navigate(["/blog-list"]);
        }
      }
    )
  }
  GetBlogCategoryList() {
    this.blogService.getBlogActiveCategory().subscribe(
      data => {
        this.blogCategoryList = data;
      }
    )
  } 
//   FormData.get(){

//};
  GetBlogStatus() {
    this.blogService.GetBlogStatus().subscribe(
      data => {
        this.blog.blogStatus = data;
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
      this.fileToUpload = null;
      this.fd = new FormData();
      this.mediaImageShow = true;
      this.selectedBlogLogo = "";
    this.blog.blogLogo = "";
    this.blog.blogLogo = Image.fileName;

    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.mediaImageShow = false;
    this.selectedBlogLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {
    this.selectedBlogLogo = "";
    this.blog.blogLogo = "";
    this.modalRef.hide();
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }

      }
    )
  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl + "/blog";
      });
  }
  uploadBlogLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("BlogLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.blog.blogLogo = "";
      this.mediaImageShow = true;
      this.selectedBlogLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.blog.url = Value.toLowerCase();
  }
  onSubmit() {
    if (this.blog.sortOrder == null) {
      this.blog.sortOrder = 0;
    }
    this.blogService.isUniqueUrl(this.blog.url, this.blog.blogId).subscribe(
      data => {
        if (data == true) {
          this.isUnique = true;
          this.validate = false;
          this.blog.isActive = true;
          this.blog.detail = this.longDetail;
          this.blogService.AddBlog(this.blog).subscribe(result => {
            if (result) {
              this.toastr.success('Blog has been Saved. ', 'Success');
              this.fd.append("BlogId", result.toString());
              this.blogService.AddBlogLogo(this.fd, this.userId);
            }
            else {
              this.toastr.error('Error occurred. Oop!', 'Success');
            }
          });
        }
        else {
          this.isUnique = false;
        }
      });
      }

}



// WEBPACK FOOTER //
// ./src/app/blog-components/create-blog/create-blog.component.ts